// 上传状态
export enum UploadStatus {
  // 上传中
  Loading = '999',
  // 初始化
  Init = '0',
  // 算法处理中
  Processing = '1',
  // COS生成封面中
  CoverGeneratting = '2',
  // 失败
  Error = '3',
  // 已删除
  Deleted = '4',
  // 上传成功
  Success = '5',
}
